import React from "react";
import TextLink from "@streeteasy/design-system/deprecated/TextLink";
import SuccessMessageModal from "@streeteasy/design-system/legacy/SuccessMessageModal";
import { func, object, shape, string } from "prop-types";

import AgentBoxContent from "../AgentBoxContent";

const PasswordRequestedConfirmation = props => {
  const modalTitle = props.data.sourceGroup ? (
    <>
      You contacted <br /> {props.data.agent}
    </>
  ) : (
    props.data.confirmationHeader || "Your message was sent"
  );

  return (
    <SuccessMessageModal isOpen onClose={props.handleCloseModal}>
      <SuccessMessageModal.Body>
        <SuccessMessageModal.SuccessIcon />
        <SuccessMessageModal.Title>{modalTitle}</SuccessMessageModal.Title>
        <SuccessMessageModal.Text>
          {props.data.confirmationText}
        </SuccessMessageModal.Text>
      </SuccessMessageModal.Body>
      {props.data.sourceGroup && (
        <SuccessMessageModal.CustomContent>
          <AgentBoxContent
            agent={props.data.agent}
            agentUrl={props.data.agentUrl}
            logoUrl={props.data.logoUrl}
            sourceGroup={props.data.sourceGroup}
          />
        </SuccessMessageModal.CustomContent>
      )}
      <SuccessMessageModal.Footer>
        <TextLink
          href="#"
          onClick={e => {
            props.setScenario("PasswordRequested", {
              email: props.data.email,
              origin: props.data.origin
            });
            e.preventDefault();
          }}
          theme="primaryTouchedBoldUnderline"
        >
          sign in to access your account
        </TextLink>
      </SuccessMessageModal.Footer>
    </SuccessMessageModal>
  );
};

PasswordRequestedConfirmation.propTypes = {
  data: shape({
    confirmationText: object.isRequired,
    email: string.isRequired,
    origin: string.isRequired
  }).isRequired,
  handleCloseModal: func.isRequired,
  setScenario: func.isRequired
};

export default PasswordRequestedConfirmation;
